import React from 'react'
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import '../Assets/index.css';
import '../Assets/bootstrap.css';
import {ToastContainer} from "../Component/Toast/ToastContainer";
import {Toaster} from 'react-hot-toast'
import Employee from './Employee'
import Personal from './Personal'
import Admin from './Admin'
import Scanner from './Scanner'
import NotFound from './NotFound';
import UserNotOnboarded from './Errors/mmt'

function Index() {
	return (
		<>
		<ToastContainer />
		<Toaster/>
		<BrowserRouter>
			<Switch>
				<Route path="/error/mmt" component={UserNotOnboarded} />
				<Route path="/scanner" component={Scanner} />
				<Route path="/personal" component={Personal} />
				<Route path="/admin" component={Admin} />
				<Route path="/user" component={Employee} />
				<Route path="/" component={Employee} />
				<NotFound/>
			</Switch>
		</BrowserRouter>
		</>
	)
}

export default Index
